module.exports = __webpack_public_path__ + "media/images/voice05-2-0d88009b0a5c4671246c3225f1ac6c1c.jpg";